import React from "react";
import { useAccount, useDisconnect } from "wagmi";

/**
 * Shared "Connected as 0x…ABCD · Change" row. Consumed by the
 * ready / working / error states inside CheckoutPanel so the
 * connected-wallet identity is consistent across phases.
 *
 * `onChange` is fired before the disconnect so the parent can
 * reset pending pay-hook state (e.g. clear a lingering
 * "signing…" flag from a previously-active method).
 */
export function ConnectedWalletRow({ onChange }) {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  if (!address) return null;

  return (
    <div className="pay-connected-row">
      <span>
        Connected as{" "}
        <code>
          {address.slice(0, 6)}…{address.slice(-4)}
        </code>
      </span>
      <button
        type="button"
        className="pay-connected-row__change"
        onClick={() => {
          if (onChange) onChange();
          disconnect();
        }}
      >
        Change
      </button>
    </div>
  );
}
